import { Component, OnInit, Inject, Input, Output, EventEmitter} from '@angular/core';
import { ReportsColumnsDialogComponent } from '../reports/reports.columns.dialog.component';
import { WebStorageService, SESSION_STORAGE } from 'ngx-webstorage-service';
import { DatePipe } from '@angular/common';
import { UserPrincipal } from '../services/auth/userPrincipal.model';
import { Constants } from '../data-models/constants.enum';

@Component({
    selector: 'app-show-hide-pop-up',
    templateUrl: './show-hide-pop-up.component.html',
    styleUrls: ['./show-hide-pop-up.component.css'],
    standalone: false
})
export class ShowHidePopUpComponent extends ReportsColumnsDialogComponent implements OnInit {

  @Input() visibleColumns
  @Input() showHideDialogModal
  @Input() columns
  @Input() dynamicTableComponent : any

  userDetails: UserPrincipal;
  workListFlagEnabled: any;
  filteredVisibleColumns: any[];
  
  constructor(@Inject(SESSION_STORAGE) public sessionStorage: WebStorageService,
  public dateFormat: DatePipe) {
    super(sessionStorage,dateFormat);
   }

  ngOnInit() {
    this.userDetails = this.sessionStorage.get(Constants.userPrincipal);
    this.workListFlagEnabled = this.userDetails?.workListFlagEnabled;
    this.filterColumns();
  }

  filterColumns() {
    if (this.workListFlagEnabled !== 'Y') {
      this.filteredVisibleColumns = this.visibleColumns.filter(column => column.label !== 'Flag');
    } else {
      this.filteredVisibleColumns = this.visibleColumns;
    }
  }
}
